class LogoMarquee extends HTMLElement {
  constructor() {
    super();
    this.marqueeContent = this.querySelector('.marquee-content');
    this.marqueeItems = this.marqueeContent.children;
    this.speed = 0.05; // Pixels per millisecond
    this.totalWidth = 0;
    this.currentPosition = -75; // Start at -75%
    this.lastTimestamp = 0;
  }

  connectedCallback() {
    this.calculateTotalWidth();
    this.startAnimation();
  }

  calculateTotalWidth() {
    this.totalWidth = Array.from(this.marqueeItems).reduce((sum, item) => sum + item.offsetWidth, 0);
  }

  startAnimation() {
    this.lastTimestamp = performance.now();
    this.animationFrame = requestAnimationFrame(this.animate.bind(this));
  }

  animate(timestamp) {
    const elapsed = timestamp - this.lastTimestamp;
    this.lastTimestamp = timestamp;

    this.currentPosition -= (this.speed * elapsed * 100) / this.totalWidth;
    if (this.currentPosition <= -100) {
      this.currentPosition += 100;
    }

    this.marqueeContent.style.transform = `translateX(${this.currentPosition}%)`;

    this.animationFrame = requestAnimationFrame(this.animate.bind(this));
  }

  disconnectedCallback() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  }
}

customElements.define('logo-marquee', LogoMarquee);
